import React from "react";
import EntitiesLoader from "../../../components/Entities/EntitiesLoader/EntitiesLoader";
import {EntityServiceName} from "../../../api/enums/enums";
//TODO change form
import EvEntityRowForm from "../../EvInfrastructure/EvManagement/EvEntityRowForm";
import {RoadInfrastructureEntityName} from "../../../api/types/types";


const getUrlFunc = ({id}: any) => `./${id}/edit`

const DistrictsList = () => {
    const serviceName = EntityServiceName.ROAD_INFRASTRUCTURE;

    return (
        <EntitiesLoader
            entityName={RoadInfrastructureEntityName.District}
            layerEntityName={RoadInfrastructureEntityName.District}
            serviceName={serviceName}
            form={EvEntityRowForm}
            // linkable={true}
            getUrlFunc={getUrlFunc}
        />
    )
}

export default DistrictsList;